import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../App";
import { useTranslation } from "../i18n";
import {
  container,
  containerRight,
  SwitchContainer,
  SwitchItem,
} from "./UserHeader.style";

const Switch = function () {
  const { language, setLanguage } = useContext(GlobalContext);
  const [isZh, setIsZh] = useState(() => language === "zh-CN");

  useEffect(() => {
    const value = isZh ? "zh-CN" : "en-US";

    setLanguage(value);
    localStorage.setItem("lang", value);
  }, [isZh, setLanguage]);

  return (
    <div style={SwitchContainer}>
      <span style={SwitchItem(!isZh)} onClick={() => setIsZh(false)}>
        EN
      </span>
      <span style={SwitchItem(isZh)} onClick={() => setIsZh(true)}>
        中
      </span>
    </div>
  );
};

const UserHeader = function () {
  const { t } = useTranslation();

  return (
    <>
      <div style={container}>
        <img src="/images/logo.svg" width={110} height={32} alt="" />
        <div style={containerRight}>
          {t("language.set")}
          <Switch />
        </div>
      </div>
      <h1>{t("subTitle")}</h1>
    </>
  );
};

export default UserHeader;
